import styled from 'styled-components'

export const EmptyChevron = styled.div`
	width: 20px;
`
